import {
  FilterCode,
  FilterContainerCode,
  IProductFilterGroup,
} from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';

export const isCategoryFilter = (code: FilterCode | string): boolean =>
  [FilterCode.model, FilterCode.bodyType].includes(code as FilterCode);

export const filterGroups: IProductFilterGroup[] = [
  {
    code: FilterContainerCode.vehicle,
    icon: 'bds/car/24',
    filters: [],
    sideFilters: [FilterCode.model, FilterCode.bodyType, FilterCode.brand, FilterCode.modelDesignation],
    name: undefined,
  },
  {
    code: FilterContainerCode.stockType,
    icon: 'bds/calendar/24',
    filters: [],
    sideFilters: [FilterCode.stockType],
    name: undefined,
  },
  {
    code: FilterContainerCode.price,
    icon: 'bds/calculator/24',
    filters: [],
    sideFilters: [FilterCode.priceValue, FilterCode.monthlyRate],
    name: undefined,
  },
  {
    code: FilterContainerCode.campaign,
    icon: 'bds/special-offer/24',
    filters: [],
    sideFilters: [FilterCode.badges],
    name: undefined,
  },
  {
    code: FilterContainerCode.engine,
    icon: 'bds/engine/24',
    filters: [],
    sideFilters: [FilterCode.fuelType, FilterCode.combinedPower, FilterCode.gearBox, FilterCode.driveType],
    name: undefined,
  },
  {
    code: FilterContainerCode.transportUsage,
    icon: 'bds/van-configuration/24',
    filterNames: ['transportUsage'],
    filters: [],
    sideFilters: [
      FilterCode.maxLoad,
      FilterCode.loadingSpaceVolume,
      FilterCode.loadingSpaceWidth,
      FilterCode.loadingSpaceHeight,
      FilterCode.loadingSpaceLength,
      FilterCode.maxWeight,
      FilterCode.numberOfSeats,
    ],
    name: undefined,
  },
  {
    code: FilterContainerCode.upholstery,
    icon: 'bds/seat/24',
    filterNames: ['upholstery_polish', 'upholstery_group'],
    filters: [],
    sideFilters: [FilterCode.upholsteryGroup, FilterCode.upholsteryPolish],
    name: undefined,
  },
  {
    code: FilterContainerCode.equipment,
    icon: 'bds/wheel/24',
    filterNames: ['grouped_equipments', 'packages', 'lines'],
    filters: [],
    sideFilters: [FilterCode.lines, FilterCode.packages, FilterCode.equipmentGroups],
    name: undefined,
  },
  {
    code: FilterContainerCode.color,
    icon: 'bds/layers/24',
    filterNames: ['color_polish', 'color_group'],
    filters: [],
    sideFilters: [FilterCode.colorPolish, FilterCode.colorGroup],
    name: undefined,
  },
  {
    code: FilterContainerCode.locations,
    icon: 'bds/location/24',
    sideFilters: [FilterCode.locations],
    filters: [],
    name: undefined,
  },
];
